import React, { useRef } from "react"
import styled, { css } from 'styled-components'

import Socials from '../Socials'
import MenuItem from './MenuItem'

import { useSpring, useTransition, useChain, animated as a } from 'react-spring'

const Nav = styled(a.nav)`
  ${({ theme: { color } }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    padding: 0 3.6rem;
    padding-bottom: 10vh;
    background-color: ${color.black};
    z-index: 90;
  `}
`

const SocialFrame = styled.div`
  margin-top: 10.0rem;
`

const Menu = ({ isOpen, setOpen, targets }) => {

  const items = targets == null ? [] : targets.map(obj => obj.title)

  const openRef = useRef()
  const openAnim = useSpring({
    ref: openRef,
    from: { opacity: 0, transform: `translateX(100%)` },
    to: { opacity: isOpen ? 1 : 0, transform: isOpen ? `translateX(0)` : `translateX(100%)` },
  })

  const menuItemRef = useRef()
  const transition = useTransition(isOpen ? items : [], item => item, {
    ref: menuItemRef,
    unique: true,
    trail: 300 / items.length,
    from: { opacity: 0, transform: `translateX(100%)` },
    enter: { opacity: 1, transform: `translateX(0)` },
    leave: { opacity: 0, transform: `translateX(100%)` }
  })

  const socialRef = useRef()
  const socialAnim = useSpring({
    ref: socialRef,
    from: { opacity: 0, transform: `translateX(100%)` },
    to: { opacity: isOpen ? 1 : 0, transform: isOpen ? `translateX(0)` : `translateX(100%)` },
  })

  useChain(
    isOpen 
      ? [openRef, menuItemRef, socialRef]
      : [menuItemRef, socialRef, openRef], 
    [0, isOpen ? 0.1 : 0.3, 0.4]
  )

  return (
    <Nav style={openAnim}>
      <ul>
        {transition.map(({ item, key, props }) => (
          <a.li
            key={key}
            style={props}
          >
            <MenuItem
              ref={targets.find(obj => obj.title === item).ref}
              isOpen={isOpen}
              setOpen={setOpen}
            >{item}</MenuItem>
          </a.li>
        ))}
      </ul>
      <a.div style={socialAnim}>
        <SocialFrame>
          <Socials />
        </SocialFrame>
      </a.div>
    </Nav>
  )
}

export default Menu